/**
 * Site-wide configuration for Container Specialist.
 * This is the single source of truth for company details, WhatsApp behaviour
 * and default SEO. Values here can later be overridden by data returned from
 * the future backend "website settings" endpoint (see settings.service.js).
 */

export const siteConfig = {
    siteName: "Container Specialist",
    registeredCompanyName: "MK Holdings Pte Ltd",
    uen: "201021748R",
    yearEstablished: 2010,
    email: "info@container.com.sg",
    mobile: "+65 90214919",
    mobileRaw: "6590214919",
    whatsappNumber: "6590214919",
    whatsappUrl: "https://wa.me/6590214919",
    address: {
        line1: "48 Toh Guan Road East",
        line2: "Enterprise Hub",
        unit: "#04-124",
        postal: "Singapore 608586",
        full: "48 Toh Guan Road East, Enterprise Hub, #04-124, Singapore 608586",
    },
    googleMapsEmbedUrl:
        "https://www.google.com/maps?q=48+Toh+Guan+Road+East+Enterprise+Hub+Singapore+608586&output=embed",
    siteUrl: "https://www.container.com.sg",
    socialLinks: {
        facebook: "",
        instagram: "",
        linkedin: "",
    },
    defaultSeo: {
        title: "New, Used & Customised Containers Singapore | Container Specialist",
        description:
            "Buy new, used and customised shipping containers in Singapore. Storage, office, cargo-worthy, workers' quarters, sanitary and custom container solutions.",
        keywords: [
            "containers Singapore",
            "shipping containers for sale Singapore",
            "new containers Singapore",
            "used containers Singapore",
            "customised containers Singapore",
            "storage containers Singapore",
            "container office Singapore",
        ],
        ogImage: "https://images.unsplash.com/photo-1614568111321-aaefe48192e2?auto=format&fit=crop&w=1600&q=80",
    },
};

export const trustHighlights = [
    "Established Since 2010",
    "New and Used Options",
    "Customisation Available",
    "Multiple Sizes Available",
    "Singapore-Based Support",
];

export const primaryNav = [
    { label: "Home", href: "/" },
    { label: "About Us", href: "/about-us" },
    { label: "Our Containers", href: "/containers" },
    { label: "Blogs", href: "/blogs" },
    { label: "Contact Us", href: "/contact-us" },
];
